@use '../../../../styles/scss/vcom/mixins/breakpoints';
@use '../../../../styles/scss/vcom/themes/classic/colors' as classic;

.vs-toggle-container {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 12px 32px;
  margin: 0 auto;
  
  @include breakpoints.desktop-plus-up{
    padding: 30px 24px;
  }
}

.vs-toggle-container.lightBlue {
  background-color: classic.$vs-lightBlue;
}

.vs-toggle-container.white {
  background-color: classic.$vs-white;
}

.vs-toggle-container.lightGray {
  background-color: classic.$vs-tertiary-1;
}

.vs-toggle-container.lightYellow {
  background-color: classic.$vs-lightYellow;
}


.vs-toggle-wrapper {
  background-color: classic.$vs-white;
  border-radius: 30px;
  display: inline-flex;
  max-width: 100%;
  border: 1px solid classic.$vs-tertiary-5;
  border: 1px solid #808080;
  height: 36px;

  @include breakpoints.desktop-plus-up{
    height: 50px;
  }

  @include breakpoints.mobile{
    height: fit-content;
  }

}

.vs-toggle-btn {
  border: none;
  background: classic.$vs-white;
  border-radius: 30px;
  font-size: 14px !important;
  line-height: 18px !important;
  position: relative;
  margin: 0 !important;
  padding: 9px 17px;
  text-decoration: none;

  @include breakpoints.mobile {
    text-align: center;
    word-break: break-word;
    overflow: hidden;
    padding: 8px 17px;
  }

  @include breakpoints.desktop-plus-up{
    font-size: 20px !important;
    line-height: 30px !important;
  }
}

.vs-toggle-btn.active {
  background-color: classic.$vs-primary;
  color: classic.$vs-white;
  cursor: default;
}

.vs-toggle-btn:not(.active){
  color: classic.$vs-tertiary-6;
  color: #5C5C5C;
}

.vs-toggle-btn.active:hover {
  text-decoration: none;
}

.vs-toggle-btn:hover:not(.active) {
  text-decoration: none;
  color: classic.$vs-tertiary-7;
  color: #2C2C2C;
}

.vs-toggle-btn.active:focus {
  outline: dashed 1.5px classic.$vs-white !important;
  outline-offset: -3px;
  text-decoration: none;
}

.vs-toggle-btn:focus:not(.active) {
  outline: dashed 1.5px classic.$vs-black !important;
  outline-offset: -3px;
  text-decoration: none;
  color: classic.$vs-tertiary-6;
  color: #5C5C5C;
}





